export const collectionName = {
    universities: 'universities',
    courses: 'courses',
    sequenceInfo: 'sequenceInfo',
    config: 'config'
}